import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { environment } from "environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class ChatGuard implements CanActivate {

    config = environment;

    constructor(private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        if (route.routeConfig?.path === "fullscreen" && route.queryParamMap.has("id") && route.queryParamMap.has("message")) {
            return true;
        }

        if (route.routeConfig?.path === "" && !this.config.production) {
            return true;
        }
        return this.router.createUrlTree(["/empty-state"]);
    }
}